import catalogData from '../data/bend-catalog.json' with { type: 'json' };
const catalog = catalogData;
const byCode = new Map(catalog.map((b) => [b.code, b]));
export function getBendType(code) {
    const b = byCode.get(code);
    if (!b)
        throw new Error(`Unknown bend type: "${code}"`);
    return b;
}
export function listBendTypes(filter) {
    return catalog.filter((b) => {
        if (filter?.family && b.family !== filter.family)
            return false;
        if (filter?.barSize !== undefined && !b.validBarSizes.includes(filter.barSize))
            return false;
        return true;
    });
}
